import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const initialState = {
  mouseX: null,
  mouseY: null,
};

export default function ContextMenu({ menuItem, actionItems, actions, idKey }) {
  const [state, setState] = React.useState(initialState);
  let actionIndex = -1;
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleClose = () => {
    setState(initialState);
  };

  const renderedActionItems = actionItems.map((item) => {
    actionIndex++;
    let cbEvent = actions[actionIndex];
    return (
      <MenuItem key={item} onClick={() => cbEvent(idKey)}>
        {item}
      </MenuItem>
    );
  });

  return (
    <div onContextMenu={handleClick} style={{ cursor: "context-menu" }}>
      {menuItem}
      <Menu
        keepMounted
        open={state.mouseY !== null}
        onClick={handleClose}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          state.mouseY !== null && state.mouseX !== null
            ? { top: state.mouseY, left: state.mouseX }
            : undefined
        }
      >
        {renderedActionItems}
      </Menu>
    </div>
  );
}
